import React, { useCallback, useEffect, useState, useRef } from 'react'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Table,
} from "reactstrap"
import { ADMIN_USER_TYPE_ID, ERROR_KEY, TICKET_STATUSES } from '../../../Constants/MainKeys'
import { addButtonSpinner, addRightSectionSpinner, removeButtonSpinner, removeRightSectionSpinner } from '../../../store/spinner/actions'
import AlertService from '../../../Services/alertService'
import { useDispatch, useSelector } from 'react-redux'
import HtmlHead from '../../../components/HtmlHead/HtmlHead'
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner'
import uuid from 'react-uuid'
import NoData from '../../../components/NoData/NoData'
import ApiService from '../../../Services/ApiService'
import moment from 'moment'
import MainService from '../../../Services/MainService'
import AnswerModal from './components/AnswerModal'
import { DropdownButton, Dropdown, ButtonGroup } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'
import OverlayTriggerComponent from '../../../components/OverlayTriggerComponent/OverlayTriggerComponent'
import { useWindowSize } from '../../../components/Hooks/useWindowSize'



const buttonSpinnerId = uuid();

const TicketsPage = () => {

  const title = "Tickets";
  const description = "";
  const pageSize = 20;

  const dispatch = useDispatch();
  const { language } = useSelector(state => state.Languages);
  const { buttonSpinners } = useSelector(state => state.Spinners);
  const { user } = useSelector(state => state.Login);
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const [currentPage, setCurrentPage] = useState(1);
  const [activePageNumber, setActivePageNumber] = useState(0);
  const [tickets, setTickets] = useState([]);
  const [currentItem, setCurrentItem] = useState(null);
  const [answerText, setAnswerText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isClientAnswer, setIsClientAnswer] = useState(false);
  const [isStatusLoading, setIsStatusLoading] = useState(false);
  const [isShowPagination, setIsShowPagination] = useState(false);
  const windowSize = useWindowSize();

  useEffect(() => {
    getTickets(currentPage);
  }, [])

  const getTickets = (_currentPage) => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getTickets(_currentPage, pageSize).then(response => {
      if (response && response.data && response.data.length) {
        if (response.data.length === pageSize) {
          setIsShowPagination(true);
        } else {
          setIsShowPagination(false);
        }
        setTickets([...tickets, ...response.data]);
        setCurrentPage(_currentPage);
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId)
    })
  }

  const getTicketById = (item, spinnerId) => {
    if (!item) { return false }
    setButtonSpinner(spinnerId);

    ApiService.getTicketById(item.id).then(response => {
      if (response && response.data) {
        setCurrentItem(response.data);
      }
    }).catch(error => getFail(error)).finally(() => {
      extractButtonSpinner(spinnerId)
    })
  }

  const updateTicketStatus = (item, newStatus) => {
    if (!item || !newStatus) { return false }
    setIsStatusLoading(true);
    ApiService.updateTicketStatus(item.id, newStatus).then(() => {
      setTickets(prevTickets =>
        prevTickets.map(ticket =>
          ticket.id === item.id
            ? { ...ticket, ticketStatus: +newStatus }
            : ticket
        )
      );
    }).catch(error => getFail(error)).finally(() => {
      setIsStatusLoading(false);
    })
  }

  const handlePageClick = (event) => {
    setActivePageNumber(event.selected);
  };

  const cancel = () => {
    setAnswerText("");
    setCurrentItem(null);
    setIsClientAnswer(false);
  }

  const onSubmit = (event) => {
    event && event.preventDefault();
    setIsLoading(true);
    const answerData = {
      ticketId: currentItem.id,
      answer: answerText,
    }
    if (user.userTypeId !== ADMIN_USER_TYPE_ID) {
      answerData.isClientAnswer = true;
    } else {
      answerData.isClientAnswer = isClientAnswer;
    }
    ApiService.anserTicket(answerData).then((response) => {
      if (response && response.data) {
        let currentItemCopy = { ...currentItem };
        let data = { ...response.data };
        if (data && data.createTime && data.createTime.includes("Z")) {
          data.createTime = data.createTime.replace("Z", "")
        }
        currentItemCopy.ticketAnswers = [...currentItemCopy.ticketAnswers, data];
        setCurrentItem(currentItemCopy);
      }
      setAnswerText("");
      setIsClientAnswer(false);
    }).catch((error) => getFail(error)).finally(() => {
      setIsLoading(false);
    })
  }

  const onChange = (event, cb, maxLength = Infinity) => {
    if (maxLength && maxLength < event.target.value.length) { return; }
    cb(event.target.value)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        return;
      }
      e.preventDefault();
      if (answerText.trim()) {
        onSubmit();
      }
    }
  };

  const getStatusTitle = (item) => {
    const currentStatus = TICKET_STATUSES.find(el => el.value === item.ticketStatus);
    if (currentStatus) {
      return currentStatus?.label || "";
    } else {
      return ""
    }
  }

  const getStatusVariant = (item) => {
    if (!item) {
      return "secondary"
    }
    switch (item.ticketStatus) {
      case 0:
        return "info"
      case 1:
        return "warning"
      case 2:
        return "danger"
      case 3:
        return "success"
      case 4:
        return "secondary"
      default:
        return "secondary"
    }
  }

  const setButtonSpinner = useCallback(spinner => {
    dispatch(addButtonSpinner(spinner));
  }, []);

  const extractButtonSpinner = useCallback(spinner => {
    dispatch(removeButtonSpinner(spinner));
  }, []);

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <>
      <AnswerModal
        currentItem={currentItem}
        isClientAnswer={isClientAnswer}
        answerText={answerText}
        setAnswerText={setAnswerText}
        isLoading={isLoading}
        cancel={cancel}
        setIsClientAnswer={setIsClientAnswer}
        onChange={onChange}
        handleKeyDown={handleKeyDown}
        onSubmit={onSubmit}
      />
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />
        <div className='container-fluid'>
          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Tickets"
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>
                        Tickets
                      </span>
                      {
                        user.userTypeId === ADMIN_USER_TYPE_ID ? null :
                          <Link to={`/${language}/customer-support`} className='btn btn-primary d-flex align-items-center nowrap' color='primary' >+ Add Ticket</Link>
                      }
                    </div>
                    <hr />
                  </CardTitle>
                  {
                    tickets && tickets.length ?
                      <React.Fragment>


                        <div>
                          <Table striped bordered hover responsive>
                            <thead>
                              <tr>
                                <th className="text-nowrap">#</th>
                                <th className="text-nowrap">Ticket Number</th>
                                <th className="text-nowrap">Status</th>
                                <th className="text-nowrap">Date</th>
                                <th className="text-nowrap">Business Name</th>
                                <th className="text-nowrap">First Name</th>
                                <th className="text-nowrap">Last Name</th>
                                <th className="text-nowrap">E-Mail</th>
                                <th className="text-nowrap">Message</th>
                                <th className={`text-nowrap ${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {tickets.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <div className='d-flex gap-2 align-items-center'>
                                        <span>{item.ticketNumber}</span>
                                        <i className='bx bx-copy cursor-pointer fs-5'
                                          onClick={() => {
                                            navigator.clipboard.writeText(item.ticketNumber);
                                            AlertService.alert("success", "Copied!")
                                          }}
                                        ></i>
                                      </div>
                                    </td>
                                    <td>
                                      <DropdownButton
                                        as={ButtonGroup}
                                        id={`dropdown-button-drop-up`}
                                        drop="up"
                                        className={`${user.userTypeId === ADMIN_USER_TYPE_ID ? "" : "readonly"}`}
                                        disabled={isStatusLoading}
                                        variant={getStatusVariant(item)}
                                        size="sm"
                                        title={
                                          <span>
                                            {getStatusTitle(item)}
                                            {
                                              user.userTypeId === ADMIN_USER_TYPE_ID ?
                                                <i className="bx bxs-down-arrow ms-1" style={{ fontSize: "10px" }}></i>
                                                : null
                                            }
                                          </span>
                                        }
                                        onSelect={(eventKey) => {
                                          updateTicketStatus(item, eventKey)
                                        }}
                                      >
                                        {TICKET_STATUSES.map((status, index) => (
                                          <Dropdown.Item key={index} eventKey={status.value}>
                                            {status.label}
                                          </Dropdown.Item>
                                        ))}
                                      </DropdownButton>
                                    </td>
                                    <td><span className='text-nowrap'>{moment(MainService.convertUTCDateToLocalDate(new Date(item.createTime))).format('LL HH:mm')}</span></td>
                                    <td> <span>{item.legalBusinessName}</span></td>
                                    <td> <span>{item.firstname}</span></td>
                                    <td> <span>{item.lastname}</span></td>
                                    <td>
                                      <div className='d-flex gap-2 align-items-center'>
                                        <span>{item.email}</span>
                                        <i className='bx bx-copy cursor-pointer fs-5'
                                          onClick={() => {
                                            navigator.clipboard.writeText(item.email);
                                            AlertService.alert("success", "Copied!")
                                          }}
                                        ></i>
                                      </div>
                                    </td>
                                    <td style={{ minWidth: "300px" }}><span className='max-line-3' title={item.message}>{item.message}</span></td>
                                    <td className={`${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>
                                      <OverlayTriggerComponent text='View Info'>
                                        <Link
                                          to={`#`}
                                          className={`shadow-sm me-2 text-nowrap btn btn-primary ${buttonSpinners.includes(`${buttonSpinnerId}_${item.id}`) ? "disabled" : ""}`}
                                          onClick={(event) => {
                                            event.preventDefault();
                                            getTicketById(item, `${buttonSpinnerId}_${item.id}`)
                                          }}
                                        >
                                          {
                                            buttonSpinners.includes(`${buttonSpinnerId}_${item.id}`) ?
                                              <i className="bx bx-loader bx-spin table-icon"></i>
                                              : <i className="bx bx-show table-icon" />
                                          }
                                        </Link>
                                      </OverlayTriggerComponent>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                        {
                          isShowPagination ?
                            <div className='text-center mt-2'>
                              <Button
                                type="button"
                                color="primary"
                                outline
                                className='shadow-sm text-nowrap me-2 px-5'
                                style={{ margin: "0 auto" }}
                                // disabled={buttonSpinners.includes(`${buttonSpinnerId}_${item.id}`) ? true : false}
                                onClick={() => getTickets(currentPage + 1)}
                              >
                                More
                              </Button>
                            </div>
                            : null
                        }
                      </React.Fragment>
                      : <div>
                        <NoData width={200} />
                        {
                          user.userTypeId !== ADMIN_USER_TYPE_ID ?
                            <p className='fw-500 text-center'>You don't have any tickets yet. Click <Link className='text-underline' to={`/${language}/customer-support`}>here</Link> to create one.</p>
                            : null
                        }
                      </div>
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div >
    </>
  )
}

export default TicketsPage